import React, { Component } from 'react'
import getBrowserWidth from '../functions/getBrowserWidth'
import { getInterscrollerInsertNumber } from '../functions/weischerHelpers'


const hasGridInformation = WrappedComponent => {
    class HasGridInformation extends Component {
        constructor(props) {
            super(props)

            this.state = {
                gridCols: 3
            }

            this.updateDimensions = this.updateDimensions.bind(this)
            this.getGridCols = this.getGridCols.bind(this)
        }

        componentDidMount() {
            this.updateDimensions()
            this.debouncedUpdateDimensions =  _.debounce(this.updateDimensions, 300)
            window.addEventListener("resize", this.debouncedUpdateDimensions)
        }
        
        componentWillUnmount() {
            this.debouncedUpdateDimensions.cancel()
            window.removeEventListener("resize", this.debouncedUpdateDimensions)
        }

        getGridCols(width) {
            if(this.props.trailerGrid) {
                if(width >= 1450) {
                    return 4
                } else if(width >= 1220 && width <= 1449) { 
                    return 3
                } else if(width >= 775 && width <= 1219) {
                    return 2
                } else {
                    return 1
                }
            } else if (this.props.theme === 'Arthouse') {
                if(width >= 1450) {
                    return 4
                } else if(width >= 1220 && width <= 1449) { 
                    return 3
                } else {
                    return 3
                }
            } else {
                if(width >= 1220) {
                    return 6
                } else if(width >= 760 && width <= 1219) {
                    return 4
                } else {
                    return 3
                }
            }
        }

        getMovieInformationOrder(gridCols, insertNumber) {
            const { activeItem, activeItemIndex } = this.props
            let order

            if(activeItem) {
                if(insertNumber && insertNumber < activeItemIndex) {
                    if((activeItemIndex % gridCols) > 0) {
                        order = activeItemIndex + (gridCols - (activeItemIndex % gridCols)) + 1 
                    } else {
                        order = activeItemIndex + 1 
                    }
                } else {
                    order = activeItemIndex + (gridCols - (activeItemIndex % gridCols)) 
                }
            } else {
                order = 0
            }

            return order
                
        }

        getRow(gridCols, insertNumber) {
            const { activeItem } = this.props
            let order = this.getMovieInformationOrder(gridCols, insertNumber)
            if(activeItem) {
                for(let i = 1; i < 10; i++) {
                    if (~~(order / (gridCols)) === i) {
                        return i+1
                    }
                }
            } else {
                return 0
            }
        }
                
        updateDimensions() {
            const gridCols = this.getGridCols(getBrowserWidth())

            if(gridCols !== this.state.gridCols) {
                this.setState({
                    gridCols: gridCols 
                })
            }
        }


        render() {
            const { gridCols } = this.state
            const {items, interscrollerWeischerAds, interscrollerAdvertisements } = this.props
            let insertNumber

            if(
                items.length > 6 && 
                (
                    (interscrollerWeischerAds && interscrollerWeischerAds.length > 0) ||
                    (interscrollerAdvertisements && interscrollerAdvertisements.length > 0)
                )
            ) {
                insertNumber = getInterscrollerInsertNumber(items, gridCols)
            }

            const movieInformationOrder = this.getMovieInformationOrder(gridCols, insertNumber)
            const row = this.getRow(gridCols, insertNumber)

            const injectedProps = {
                movieInformationOrder: movieInformationOrder,
                row: row,
                gridCols: gridCols
            }

            return <WrappedComponent
                {...this.props}
                {...injectedProps}
            />
        }
    }

    return HasGridInformation
}

export default hasGridInformation